/**
 * výchozí šablona pro lištu / modal verzi
 */
export const renderPaneTemplate = ({
	idPane,
	imgSrc,
	enableCloseBtn,
	enableImg,
	enableTechnicalBtn,
	disableRwdImg,
	enableModal,
	messagePane,
}) => `
<section id="${ idPane }" class="cookies-policy ${ disableRwdImg } ${ enableModal }" data-fragment="cp.pane">
	<div class="cookies-policy__container">
		${ enableCloseBtn ? `<button class="cookies-policy__btn-close" data-fragment="cp.closeBtn"><span class="cookies-policy__btn-close-text">${ messagePane.closeBtn }</span></button>` : '' }
		${ enableImg ? `<header class="cookies-policy__header"><img class="cookies-policy__img" src="${ imgSrc }" alt="" /></header>` : '' }
		<div class="cookies-policy__main">
			<h2 class="cookies-policy__heading">${ messagePane.heading }</h2>
			<p class="cookies-policy__perex">${ messagePane.perex }</p>
			<div class="cookies-policy__buttons">
				<button class="cookies-policy__btn cookies-policy__btn--secondary" data-fragment="cp.openSettingsBtn">${ messagePane.settingsBtn }</button>
				${ enableTechnicalBtn ? `<button class="cookies-policy__btn cookies-policy__btn--technical" data-fragment="cp.technicalBtn">${ messagePane.technicalBtn }</button>` : '' }
				<button class="cookies-policy__btn cookies-policy__btn--primary" data-fragment="cp.acceptAllBtn">${ messagePane.acceptAllBtn }</button>
			</div>
		</div>
	</div>
</section>
`;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/CookiesPolicy4/templates/paneTemplate.js